import styled from 'styled-components'
import { t } from 'ttag'

const AbsoluteImage = styled.img`
  position: absolute;
  bottom: 2px;
  right: 10px;
  max-width: ${({ variant }) => (variant === 'continue' ? '30%' : '40%')};
  max-height: ${({ variant }) => (variant === 'continue' ? '90%' : '70%')};
  pointer-events: none;
`
const PromotionImage = ({ src = '', variant }) => (
  <AbsoluteImage
    src={src}
    variant={variant}
    alt={t`Graphical decoration for card`}
    aria-hidden={true}
  />
)

export { PromotionImage }
